// src/utils/tokenService.js
// Handles storing, retrieving, and refreshing tokens
import Api from "./api";
import { decodeJwt } from "./jwtDecode";

// Exported function to refresh access token using refresh token
export async function refreshAccessToken() {
  const refreshToken = getRefreshToken();
  if (!refreshToken) throw new Error("No refresh token available");
  try {
    const data = await Api.post("auth/refresh", { refreshToken });
    setTokens({ token: data.token });
    return data.token;
  } catch (e) {
    clearTokens();
    throw new Error("Token refresh failed");
  }
}

const ACCESS_TOKEN_KEY = "token";
const REFRESH_TOKEN_KEY = "refreshToken";

export function setTokens({ token, refreshToken }) {
  if (token) localStorage.setItem(ACCESS_TOKEN_KEY, token);
  if (refreshToken) localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
}

export function getAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function getRefreshToken() {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
}

export function clearTokens() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
}

export async function getValidAccessToken() {
  const token = getAccessToken();
  if (!token) return null;
  const payload = decodeJwt(token);
  if (!payload || !payload.exp) return null;
  const now = Math.floor(Date.now() / 1000);
  // If token expires in less than 1 minute, refresh
  if (payload.exp - now < 60) {
    const refreshToken = getRefreshToken();
    if (!refreshToken) return null;
    try {
      const data = await Api.post("auth/refresh", { refreshToken });
      setTokens({ token: data.token });
      return data.token;
    } catch (e) {
      clearTokens();
      return null;
    }
  }
  return token;
}
